import { Injectable } from '@angular/core';
var EXIF = require('exif-js');
var ImgExifService = /** @class */ (function () {
    function ImgExifService() {
    }
    ImgExifService.prototype.getOrientedImage = function (image) {
        var result = new Promise(function (resolve, reject) {
            var img;
            if (!EXIF) {
                EXIF = {};
                EXIF.getData = function (img, callback) {
                    callback.call(image);
                    return true;
                };
                EXIF.getTag = function () { return false; };
            }
            EXIF.getData(image, function () {
                var orientation = EXIF.getTag(image, "Orientation");
                if (orientation != undefined && orientation != 1) {
	    var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d"), cw = image.naturalWidth, ch = image.naturalHeight, cx = 0, cy = 0, deg = 0;
	    switch (orientation) {
		case 3:
		case 4:
		    cx = -image.naturalWidth;
		    cy = -image.naturalHeight;
		    deg = 180;
		    break;
		case 5:
		case 6:
		    cw = image.naturalHeight;
		    ch = image.naturalWidth;
		    cy = -image.naturalHeight;
		    deg = 90;
		    break;
		case 7:
		case 8:
		    cw = image.naturalHeight;
		    ch = image.naturalWidth;
		    cx = -image.naturalWidth;
		    deg = 270;
		    break;
		default:
		    break;
	    }
	    canvas.width = cw;
	    canvas.height = ch;
	    if ([2, 4, 5, 7].indexOf(orientation) > -1) {
		//flip image
		ctx.translate(cw, 0);
		ctx.scale(-1, 1);
	    }
	    ctx.rotate(deg * Math.PI / 180);
		ctx.drawImage(this, cx, cy);
		img = document.createElement("img");
		img.width = cw;
                    	img.height = ch;
                    	img.addEventListener('load', function () {
                        	resolve(img);
                    	});
                    	img.src = canvas.toDataURL("image/png");
		    }
                else {
                    resolve(image);
                }
            });
        });
        return result;
    };
    ImgExifService.decorators = [
        { type: Injectable },
    ];
    return ImgExifService;
}());
export { ImgExifService };
//# sourceMappingURL=img-exif.service.js.map



//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-max/dist/src/img-exif.service.js
// module id = ./node_modules/ng2-img-max/dist/src/img-exif.service.js
// module chunks = 0